import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function ProtectedRoute({ children, adminOnly = false, partnerOnly = false, roles = null }) {
  const { user } = useAuth();
  const location = useLocation();

  if (user === null) {
    return (
      <div
        className="min-h-screen flex items-center justify-center bg-black text-white font-display"
        data-testid="auth-loading"
      >
        <div className="theme-text animate-pulse">CONNECTING TO GRID…</div>
      </div>
    );
  }

  if (!user) {
    const redirect = adminOnly ? "/admin/login" : "/login";
    return <Navigate to={redirect} state={{ from: location }} replace />;
  }

  if (adminOnly && user.role !== "admin") {
    return <Navigate to="/" replace />;
  }
  if (partnerOnly && user.role !== "investor") {
    return <Navigate to="/dashboard" replace />;
  }
  if (roles && Array.isArray(roles) && !roles.includes(user.role)) {
    return <Navigate to="/" replace />;
  }

  return children;
}
